module.exports = __webpack_public_path__ + "img/maldives.3f9fdd05.svg";